import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatourpackagefrom() {


const cardData = {
keyword: "Goa Tour Package from Pune by Bus",
headingDescription: "Ruturaj Enterprises provides comfortable, well-organized, and flexible Goa Tour Package from Pune by Bus services for families, friends, corporate teams, college groups, wedding groups, senior travelers, and tourists planning a memorable Goa journey. Private buses can be arranged from Pune for customized Goa vacations, weekend breaks, beach holidays, group tours, family trips, corporate outings, and multi-day sightseeing programs, with vehicle selection based on passenger count, luggage requirements, travel duration, accommodation plans, and preferred comfort level. Travelers can choose AC, luxury, tourist, affordable, family, group, round-trip, outstation, and sightseeing-focused bus options while planning convenient transportation between Pune and Goa. A dedicated bus keeps the entire group together throughout the journey and makes it easier to coordinate beach visits, sightseeing, hotel transfers, meal breaks, nightlife areas, heritage attractions, water activities, and the return trip to Pune according to the selected itinerary.",
topPlaces: [
{
title: "Baga Beach",
description: "Baga Beach is a popular Goa destination known for its lively shoreline, water activities, beachside restaurants, and energetic evening atmosphere. A private group bus makes transportation convenient for travelers staying nearby and allows families, friends, and larger groups to coordinate beach visits with hotel transfers and other Goa sightseeing plans."
},
{
title: "Basilica of Bom Jesus",
description: "The Basilica of Bom Jesus in Old Goa is an important heritage attraction and a popular stop for travelers interested in historic churches and cultural landmarks. Group transportation by bus allows passengers to visit the basilica comfortably while keeping the complete Goa itinerary coordinated with nearby heritage sites and sightseeing locations."
},
{
title: "Dudhsagar Waterfalls",
description: "Dudhsagar Waterfalls is a renowned natural attraction associated with lush landscapes, dramatic scenery, and adventurous Goa excursions. A planned bus tour from Pune can include the surrounding travel arrangements while giving groups a practical way to manage long-distance movement, sightseeing schedules, and return transfers."
},
{
title: "Fort Aguada",
description: "Fort Aguada offers travelers a combination of historic architecture, coastal scenery, and panoramic views along the Goa coastline. Including this destination in a private bus itinerary gives groups a convenient way to organize sightseeing without separating passengers across multiple vehicles during the tour."
},
{
title: "Calangute Beach",
description: "Calangute Beach is one of Goa's well-known coastal destinations, attracting tourists for its broad shoreline, leisure activities, shopping areas, and nearby restaurants. A dedicated tour bus provides comfortable group transportation between hotels, Calangute, and other attractions while keeping the day's sightseeing schedule organized."
},
{
title: "Anjuna Beach",
description: "Anjuna Beach is known for its scenic coastal setting, relaxed atmosphere, local markets, and vibrant tourist surroundings. Groups traveling from Pune can include Anjuna in a multi-day Goa itinerary and use a dedicated bus for coordinated transfers between the beach, accommodation, restaurants, and other planned sightseeing stops."
},
{
title: "Panaji",
description: "Panaji, the capital city of Goa, provides access to cultural landmarks, riverside areas, shopping streets, churches, and city attractions. A private bus arrangement is useful for families and larger groups who want to explore Panaji while maintaining a common transportation schedule throughout their Goa holiday."
},
{
title: "Palolem Beach",
description: "Palolem Beach is a scenic destination in South Goa appreciated for its peaceful coastal surroundings, palm-lined shoreline, and relaxed holiday environment. Including Palolem in a longer Goa tour plan gives travelers an opportunity to explore South Goa while using group transportation for planned transfers and sightseeing."
},
{
title: "Chapora Fort",
description: "Chapora Fort is a historic hilltop attraction offering striking views of the surrounding coastline and river landscape. It can be included as part of a North Goa sightseeing itinerary, with a dedicated bus helping groups travel together between Chapora, nearby beaches, hotels, and other attractions."
},
{
title: "Candolim Beach",
description: "Candolim Beach provides a comfortable coastal setting for travelers looking for beach leisure, water activities, restaurants, and convenient access to North Goa attractions. A private bus tour from Pune allows larger groups to visit Candolim according to their preferred schedule while coordinating hotel pickups, sightseeing stops, and the return journey."
}
],
services: [
{
name: "Goa Bus Tour Package from Pune",
description: "Goa Bus Tour Package from Pune is suitable for families, friends, corporate groups, students, and tourist parties looking for organized transportation throughout their Goa vacation. Ruturaj Enterprises can arrange a dedicated bus according to the group size, journey duration, accommodation plan, sightseeing requirements, luggage capacity, and preferred travel comfort, helping passengers remain together from the Pune departure point until the planned return."
},
{
name: "Pune to Goa Bus Tour Package",
description: "Pune to Goa Bus Tour Package provides a practical transportation option for groups planning a multi-day road journey to Goa. The itinerary can be coordinated around beach visits, sightseeing, hotel transfers, meal breaks, leisure activities, and return travel, with suitable bus arrangements based on passenger count, luggage, AC requirements, and the overall tour schedule."
},
{
name: "Pune Goa Bus Rental",
description: "Pune Goa Bus Rental is designed for groups that prefer a private vehicle instead of arranging separate transportation for individual travelers. A dedicated bus can support family vacations, college trips, corporate outings, wedding groups, and holiday tours while providing coordinated pickup, long-distance travel, local Goa movement, sightseeing transfers, and scheduled return transportation."
},
{
name: "Pune Goa Bus Hire",
description: "Pune Goa Bus Hire offers flexible bus transportation for travelers departing from Pune and visiting different parts of Goa. Vehicle selection can be planned according to the number of passengers, luggage requirements, trip duration, preferred comfort, sightseeing schedule, and budget, making the arrangement suitable for both short weekend journeys and extended group holidays."
},
{
name: "Pune Goa Bus Booking",
description: "Pune Goa Bus Booking allows groups to plan their transportation before starting the journey and coordinate the vehicle with their complete Goa itinerary. Ruturaj Enterprises can assist with suitable bus arrangements for families, friends, tourists, corporate teams, and large groups, including planned pickup points, travel schedules, accommodation transfers, sightseeing movements, and return trips."
},
{
name: "Goa Tour by AC Bus from Pune",
description: "Goa Tour by AC Bus from Pune provides an air-conditioned travel option for groups seeking a more comfortable long-distance road journey. The AC bus can be arranged for overnight or daytime travel depending on the itinerary, with sufficient planning for luggage, passenger capacity, rest stops, hotel transfers, local sightseeing, and the return journey."
},
{
name: "Goa Holiday Bus Package Pune",
description: "Goa Holiday Bus Package Pune is suitable for travelers planning relaxing vacations that combine beaches, sightseeing, food experiences, heritage attractions, and leisure activities. A private bus keeps family members and friends together while allowing the itinerary to include multiple Goa destinations, hotel movements, planned breaks, and convenient transportation throughout the holiday."
},
{
name: "Goa Group Tour Bus from Pune",
description: "Goa Group Tour Bus from Pune is planned for larger parties such as friends, corporate teams, college groups, social organizations, and extended families traveling together. A dedicated vehicle simplifies group coordination by keeping passengers, luggage, pickup arrangements, sightseeing schedules, and return transportation under one organized travel plan."
},
{
name: "Goa Family Tour Bus Pune",
description: "Goa Family Tour Bus Pune provides convenient transportation for families traveling with children, senior members, relatives, and multiple generations. The journey can be organized around comfortable travel timings, hotel check-ins, beach visits, sightseeing stops, meal breaks, luggage requirements, and a suitable return schedule so the family can travel together without managing several separate vehicles."
},
{
name: "Luxury Bus for Goa Tour Pune",
description: "Luxury Bus for Goa Tour Pune is intended for groups looking for enhanced comfort during a long-distance Goa holiday. Depending on availability and requirements, suitable premium travel arrangements can be planned around passenger capacity, seating comfort, luggage space, journey duration, sightseeing requirements, hotel transfers, and the overall standard expected for a special group trip."
},
{
name: "Pune Goa AC Bus Rental",
description: "Pune Goa AC Bus Rental offers air-conditioned group transportation for travelers who want a comfortable road journey from Pune to Goa and back. The arrangement can support family vacations, corporate travel, weekend tours, student groups, and sightseeing programs while accommodating planned stops, luggage, hotel transfers, and local Goa transportation."
},
{
name: "Pune to Goa Tourist Bus",
description: "Pune to Goa Tourist Bus is suitable for organized sightseeing groups that want to cover multiple attractions without changing vehicles between different stages of the trip. The bus can be coordinated with beach visits, forts, churches, markets, waterfalls, hotels, restaurants, and other planned destinations according to the group's selected itinerary and travel duration."
},
{
name: "Pune Goa Outstation Bus Hire",
description: "Pune Goa Outstation Bus Hire provides dedicated transportation for groups traveling from Pune to Goa for vacations, events, family functions, corporate programs, and sightseeing tours. Ruturaj Enterprises can plan the vehicle according to passenger numbers, luggage requirements, travel duration, preferred comfort, number of local transfers, and the expected return schedule."
},
{
name: "Goa Sightseeing Bus Package Pune",
description: "Goa Sightseeing Bus Package Pune is designed for travelers who want to explore multiple Goa attractions through an organized group transportation plan. The itinerary can include North Goa, South Goa, beaches, forts, churches, markets, waterfalls, heritage locations, and other attractions while allowing the group to coordinate hotel pickups, sightseeing timings, meal breaks, and return transfers."
},
{
name: "Pune Goa Round Trip Bus",
description: "Pune Goa Round Trip Bus provides transportation for the complete journey from Pune to Goa and back to Pune without requiring travelers to arrange separate vehicles for different stages. This option works well for family vacations, group holidays, corporate trips, and weekend plans where departure, local sightseeing, hotel transfers, and the return journey need to remain synchronized."
},
{
name: "Affordable Goa Bus Tour Pune",
description: "Affordable Goa Bus Tour Pune is suitable for groups seeking practical transportation while keeping the overall tour budget under consideration. Vehicle size and travel arrangements can be planned according to passenger strength, luggage, trip duration, sightseeing requirements, AC preference, and the number of destinations included in the Goa itinerary."
},
{
name: "Goa Weekend Tour Bus Pune",
description: "Goa Weekend Tour Bus Pune is convenient for travelers planning a short Goa break with limited vacation time and a clearly scheduled itinerary. A dedicated bus can support planned overnight travel, hotel transfers, beach visits, sightseeing, leisure activities, meal stops, and the return trip while allowing friends or families to remain together throughout the weekend."
},
{
name: "Goa Beach Tour Bus from Pune",
description: "Goa Beach Tour Bus from Pune is planned for groups whose main holiday objective is to explore Goa's popular coastal destinations and nearby leisure areas. The transportation schedule can connect selected beaches with hotels, restaurants, markets, forts, and other attractions, giving passengers a coordinated way to move between destinations during the trip."
},
{
name: "Pune Goa Group Travel Bus",
description: "Pune Goa Group Travel Bus provides dedicated transportation for large parties traveling together from Pune to Goa for holidays, events, college tours, corporate outings, and family programs. A common bus simplifies coordination of passengers and luggage while supporting planned departure times, sightseeing movements, accommodation transfers, rest breaks, and return travel."
},
{
name: "Goa Tour Bus Booking Pune",
description: "Goa Tour Bus Booking Pune helps travelers arrange group transportation around their preferred Goa vacation dates, passenger capacity, itinerary, and vehicle requirements. The bus can be coordinated with hotel stays, sightseeing plans, beach visits, local transfers, luggage needs, and the return journey so that the transportation schedule remains aligned with the complete tour."
},
{
name: "Pune to Goa Luxury Bus Package",
description: "Pune to Goa Luxury Bus Package is intended for travelers seeking a more premium group travel experience during their Goa vacation. The arrangement can be planned around suitable seating capacity, comfort expectations, luggage space, long-distance travel requirements, hotel transfers, sightseeing schedules, and the duration of the complete Pune-Goa itinerary."
},
{
name: "Goa Travel Bus Rental Pune",
description: "Goa Travel Bus Rental Pune provides flexible private bus transportation for different types of Goa travel plans, including family holidays, group vacations, corporate trips, educational tours, events, and customized sightseeing programs. Ruturaj Enterprises can organize the vehicle around the selected route, passenger count, luggage, travel duration, local Goa movements, accommodation schedule, and return requirements."
}
],
tableData: [
["Goa Bus Tour Package from Pune", "Dedicated group bus transportation for customized Goa tour itineraries"],
["Pune to Goa Bus Tour Package", "Organized Pune-Goa travel with sightseeing and return journey planning"],
["Pune Goa Bus Rental", "Private bus rental for families, groups, events, and holiday travel"],
["Pune Goa Bus Hire", "Flexible bus hire based on passengers, luggage, duration, and comfort"],
["Pune Goa Bus Booking", "Pre-planned bus booking for complete Goa group travel arrangements"],
["Goa Tour by AC Bus from Pune", "Air-conditioned bus travel for comfortable long-distance Goa tours"],
["Goa Holiday Bus Package Pune", "Group transportation for customized Goa holiday and leisure itineraries"],
["Goa Group Tour Bus from Pune", "Dedicated bus for friends, corporate teams, students, and larger groups"],
["Goa Family Tour Bus Pune", "Comfortable family transportation with coordinated sightseeing and transfers"],
["Luxury Bus for Goa Tour Pune", "Premium group transportation for comfortable Goa vacations and special trips"],
["Pune Goa AC Bus Rental", "AC bus rental for family tours, corporate trips, and group holidays"],
["Pune to Goa Tourist Bus", "Tourist bus transportation for multi-attraction Goa sightseeing programs"],
["Pune Goa Outstation Bus Hire", "Long-distance private bus hire from Pune to Goa and surrounding destinations"],
["Goa Sightseeing Bus Package Pune", "Organized bus travel covering selected Goa beaches, forts, churches, and attractions"],
["Pune Goa Round Trip Bus", "Complete Pune-Goa-Pune transportation with coordinated travel scheduling"],
["Affordable Goa Bus Tour Pune", "Budget-conscious bus transportation for practical group Goa holidays"],
["Goa Weekend Tour Bus Pune", "Dedicated bus arrangement for short weekend Goa vacation plans"],
["Goa Beach Tour Bus from Pune", "Group transportation focused on Goa beach visits and coastal sightseeing"],
["Pune Goa Group Travel Bus", "Common group vehicle for coordinated passengers, luggage, and sightseeing"],
["Goa Tour Bus Booking Pune", "Planned tour bus booking aligned with itinerary, accommodation, and travel dates"],
["Pune to Goa Luxury Bus Package", "Premium bus arrangement for comfortable long-distance Goa group tours"],
["Goa Travel Bus Rental Pune", "Flexible private bus rental for customized Goa vacations and travel programs"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Long-Distance Group Travel",
WhyChoosedescription: "Long-distance travel between Pune and Goa can be easier when the complete group uses one suitable vehicle instead of managing several separate cars. Ruturaj Enterprises focuses on arranging transportation according to passenger strength, luggage requirements, journey duration, seating preferences, and the planned tour schedule for a more coordinated road journey."
},
{
WhyChooseheading: "Bus Options for Different Group Sizes",
WhyChoosedescription: "Different Goa tours require different vehicle capacities depending on the number of travelers and the amount of luggage being carried. Suitable bus arrangements can be planned for families, friends, corporate teams, students, wedding groups, and larger tourist parties while considering space, comfort, route requirements, and trip duration."
},
{
WhyChooseheading: "Flexible Goa Tour Planning",
WhyChoosedescription: "A private bus arrangement gives groups greater flexibility when building a Goa itinerary around their preferred destinations and travel timings. Beach visits, heritage attractions, hotel transfers, meal breaks, sightseeing stops, leisure activities, and return travel can be coordinated around the selected schedule rather than relying on separate transportation for every movement."
},
{
WhyChooseheading: "Suitable for Family and Group Holidays",
WhyChoosedescription: "Family vacations and group holidays often involve travelers of different ages, luggage requirements, and sightseeing preferences, making shared transportation useful for keeping everyone together. The travel plan can be organized around comfortable pickup points, planned breaks, accommodation transfers, local sightseeing, and the complete return journey to Pune."
},
{
WhyChooseheading: "AC and Premium Travel Arrangements",
WhyChoosedescription: "Travelers looking for additional comfort can select suitable AC or premium bus arrangements according to availability and group requirements. These options are particularly useful for longer journeys where seating comfort, climate-controlled travel, luggage space, and a well-planned schedule contribute to a more convenient Goa touring experience."
},
{
WhyChooseheading: "Organized Sightseeing Transfers",
WhyChoosedescription: "Goa tours commonly involve multiple destinations spread across North Goa, South Goa, and central areas, so transportation coordination becomes an important part of the itinerary. A dedicated bus helps groups move between beaches, forts, churches, markets, hotels, restaurants, and other attractions while maintaining a common schedule for all passengers."
},
{
WhyChooseheading: "Convenient Round-Trip Coordination",
WhyChoosedescription: "For travelers planning a Pune-Goa-Pune journey, round-trip bus arrangements can simplify the complete transportation process from departure through the final return. Pickup planning, long-distance travel, local movements, sightseeing schedules, accommodation transfers, luggage handling, and the return departure can be aligned with the group's planned holiday duration."
},
{
WhyChooseheading: "Practical Transportation for Customized Tours",
WhyChoosedescription: "Every Goa group trip can have different requirements based on destination selection, number of days, passenger count, budget, comfort expectations, and sightseeing priorities. Ruturaj Enterprises can structure the bus travel arrangement around these practical requirements so families, friends, corporate teams, and tourist groups can follow a transportation plan suited to their specific itinerary."
}
]
};












const faqData = [
{
question: "What is a Goa tour package from Pune by bus?",
answer: "A Goa tour package from Pune by bus is a convenient group travel arrangement that combines road transportation with a planned Goa itinerary. Ruturaj Enterprises can arrange a suitable bus according to the number of travelers, trip duration, pickup requirements, sightseeing plans, and return schedule."
},
{
question: "Which places can be covered in a Goa tour from Pune by bus?",
answer: "A Goa tour can include popular attractions and destinations such as Baga Beach, Calangute Beach, Anjuna, Vagator, Panjim, Dona Paula, Old Goa, Candolim, and other places based on the group's preferred itinerary. The sightseeing plan can be adjusted according to the available travel time."
},
{
question: "Is a bus suitable for a family Goa tour from Pune?",
answer: "Families can enjoy the convenience of traveling together in a dedicated bus instead of managing several private vehicles. A group bus provides an organized way to travel with children, relatives, and luggage while keeping everyone together during the Pune to Goa journey and local sightseeing."
},
{
question: "Can friends book a Goa tour package from Pune by bus?",
answer: "Friends and travel groups can hire a dedicated bus for a Goa vacation, weekend trip, celebration, or group outing. Traveling together makes it easier to coordinate departure times, luggage, sightseeing stops, and return plans while enjoying the road journey as a group."
},
{
question: "Can corporate groups book a Goa tour bus from Pune?",
answer: "Corporate teams can arrange bus transportation for employee outings, team-building trips, company vacations, annual gatherings, and group events in Goa. A dedicated bus keeps the team together and makes it easier to follow a common itinerary throughout the trip."
},
{
question: "Can the Goa tour itinerary be customized?",
answer: "The Goa tour itinerary can be planned according to your group's preferred destinations, travel dates, sightseeing interests, number of days, and pickup location in Pune. Ruturaj Enterprises can help arrange the transportation around the schedule selected by the group."
},
{
question: "How many people can travel in a bus for a Goa tour from Pune?",
answer: "The ideal bus capacity depends on the total number of passengers and luggage requirements. Ruturaj Enterprises can help select an appropriate vehicle for smaller groups as well as larger family, corporate, educational, or social groups planning a Pune to Goa tour."
},
{
question: "Can I book a round-trip bus for a Goa tour from Pune?",
answer: "Round-trip bus booking is a practical choice for travelers who want transportation from Pune to Goa and back to Pune after completing their vacation. The bus schedule can be coordinated with the group's sightseeing itinerary, hotel stay, departure time, and planned return date."
},
{
question: "How many days are recommended for a Goa tour from Pune by bus?",
answer: "The ideal duration depends on the number of sightseeing locations and activities included in the itinerary. A short trip can focus on major beaches and attractions, while a longer tour allows the group to explore North Goa, South Goa, heritage sites, and additional destinations at a more relaxed pace."
},
{
question: "Why choose Ruturaj Enterprises for a Goa tour package from Pune by bus?",
answer: "Ruturaj Enterprises provides group transportation solutions for travelers planning a road trip from Pune to Goa. With vehicle selection based on group size and itinerary requirements, families, friends, corporate teams, and larger groups can arrange their Goa tour with a dedicated bus and coordinated travel schedule."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Bhosale",
feedback:
"Our group planned a Goa vacation from Pune and decided to travel by a dedicated bus. Ruturaj Enterprises helped us arrange transportation suitable for our group, and traveling together made the long journey and local sightseeing much easier to coordinate. It was a comfortable and enjoyable group trip.",
rating: 5
},
{
id: 2,
name: "Miss. Anjali More",
feedback:
"We arranged a Goa tour with friends from Pune and wanted everyone to travel together. The bus arrangement through Ruturaj Enterprises made the trip more organized, especially while managing luggage and sightseeing plans. The entire group enjoyed the journey and had a memorable Goa vacation.",
rating: 5
}
];





























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa Tour Package from Pune by Bus",
  "image": "https://ruturajenterprises.com/assets/images/goa-tour-package-from-pune-by-bus.webp",
  "description":
    "Goa Tour Package from Pune by Bus from Ruturaj Enterprises is suitable for families, friends, corporate teams, college groups and other passengers planning a group holiday from Pune to Goa. Goa Bus Tour Package from Pune provides a convenient travel option for multi-day vacations, weekend holidays, group tours and customized Goa itineraries. Pune to Goa Bus Tour Package can be arranged for one-way journeys, round trips and extended sightseeing programs according to the group's travel dates, passenger count and preferred destinations. Pune Goa Bus Rental and Pune Goa Bus Hire allow groups to travel together in a dedicated vehicle, reducing the need for multiple cars during a long-distance holiday. Pune Goa Bus Booking can be planned with suitable seating capacity and pickup arrangements from convenient Pune locations. Goa Tour by AC Bus from Pune is suitable for passengers seeking a more comfortable long-distance journey, while Goa Holiday Bus Package Pune can be customized for beach vacations, family holidays, friends' trips, corporate outings and college tours. Goa Group Tour Bus from Pune is useful for larger groups travelling together, while Goa Family Tour Bus Pune provides a practical option for families planning a shared holiday itinerary. Luxury Bus for Goa Tour Pune can be considered for premium group travel and special vacation plans, while Pune Goa AC Bus Rental provides an additional comfort option for the journey. Pune to Goa Tourist Bus can support sightseeing plans covering North Goa and South Goa attractions such as Baga Beach, Calangute Beach, Anjuna Beach, Vagator Beach, Candolim, Fort Aguada, Panjim, Dona Paula, Miramar Beach, Basilica of Bom Jesus, Old Goa, Colva Beach, Benaulim, Palolem and other destinations. Pune Goa Outstation Bus Hire is suitable for multi-day travel with planned stops, hotel transfers and sightseeing schedules. Goa Sightseeing Bus Package Pune can be customized according to the group's preferred attractions and duration. Seating options such as 20 Seater, 26 Seater, 32 Seater, 35 Seater, 45 Seater and 50 Seater buses can be considered according to passenger requirements and vehicle availability. The service can also support airport transfers, hotel pickups, resort transportation, group events and return travel from Goa to Pune. Pickup arrangements can be coordinated from Kothrud, Baner, Aundh, Wakad, Hinjewadi, Viman Nagar, Kharadi, Hadapsar, Magarpatta, Kalyani Nagar, Shivajinagar, Swargate, Kondhwa, Katraj, Pimpri and Chinchwad. Ruturaj Enterprises supports Pune to Goa group travel with suitable bus capacities, planned routes, dedicated driver assistance and flexible tour arrangements.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/goa-tour-package-from-pune-by-bus"
  }
};



    return (
        <div>

<Helmet>
  <title>Goa Tour Package from Pune by Bus | Goa Bus Tour Package from Pune | +91 9763381382</title>

  <meta
    name="description"
    content="Goa Tour Package from Pune by Bus for family holidays, group tours, corporate trips and sightseeing with AC, luxury and suitable seating capacity options."
  />

  <meta
    name="keywords"
    content="Goa Bus Tour Package from Pune, Pune to Goa Bus Tour Package, Pune Goa Bus Rental, Pune Goa Bus Hire, Pune Goa Bus Booking, Goa Tour by AC Bus from Pune, Goa Holiday Bus Package Pune, Goa Group Tour Bus from Pune, Goa Family Tour Bus Pune, Luxury Bus for Goa Tour Pune, Pune Goa AC Bus Rental, Pune to Goa Tourist Bus, Pune Goa Outstation Bus Hire, Goa Sightseeing Bus Package Pune, Goa Tour Package from Pune by Bus, Goa Tour Bus Package Pune, Goa Bus Package from Pune, Goa Travel Package from Pune by Bus, Goa Holiday Package from Pune by Bus, Goa Trip Package from Pune by Bus, Goa Group Tour from Pune by Bus, Goa Family Tour from Pune by Bus, Goa Friends Trip from Pune by Bus, Goa Corporate Tour from Pune by Bus, Goa College Tour from Pune by Bus, Goa Weekend Tour from Pune by Bus, Goa Road Trip from Pune by Bus, Pune to Goa Bus Rental, Pune to Goa Bus Hire, Pune to Goa Bus Booking, Pune to Goa Bus on Rent, Pune to Goa Tourist Bus Rental, Pune to Goa Tourist Bus Hire, Pune to Goa Tourist Bus Booking, Pune to Goa Group Bus Rental, Pune to Goa Group Bus Hire, Pune to Goa Group Bus Booking, Pune to Goa Family Bus Rental, Pune to Goa Family Bus Hire, Pune to Goa Family Bus Booking, Pune to Goa Private Bus Rental, Pune to Goa Private Bus Hire, Pune to Goa Private Bus Booking, Pune to Goa Travel Bus, Pune to Goa Tour Bus Rental, Pune to Goa Tour Bus Hire, Pune to Goa Tour Bus Booking, Pune to Goa Outstation Bus Rental, Pune to Goa Outstation Bus Hire, Pune to Goa Outstation Bus Booking, Pune Goa Outstation Bus Rental, Pune Goa Outstation Bus Hire, Pune Goa Outstation Bus Booking, Pune Goa AC Bus Rental, Pune Goa AC Bus Hire, Pune Goa AC Bus Booking, AC Bus Pune to Goa, AC Bus Rental Pune to Goa, AC Bus Hire Pune to Goa, AC Bus Booking Pune to Goa, Luxury Bus Pune to Goa, Luxury Bus Rental Pune to Goa, Luxury Bus Hire Pune to Goa, Luxury Bus Booking Pune to Goa, Luxury Tourist Bus Pune to Goa, Luxury Group Bus Pune to Goa, Mini Bus Pune to Goa, Mini Bus Rental Pune to Goa, Mini Bus Hire Pune to Goa, Mini Bus Booking Pune to Goa, Non AC Bus Pune to Goa, Non AC Bus Rental Pune to Goa, Non AC Bus Hire Pune to Goa, Non AC Bus Booking Pune to Goa, Affordable Bus Rental Pune to Goa, Budget Bus Rental Pune to Goa, Bus with Driver Pune to Goa, Bus Rental with Driver Pune to Goa, Pune Goa Group Tour Bus, Pune Goa Family Tour Bus, Pune Goa Friends Tour Bus, Pune Goa Corporate Tour Bus, Pune Goa College Tour Bus, Pune Goa Wedding Bus, Pune Goa Picnic Bus, Pune Goa Holiday Bus, Pune Goa Vacation Bus, Pune Goa Sightseeing Bus, Goa Sightseeing Bus Package Pune, Goa Sightseeing Bus Rental Pune, Goa Sightseeing Bus Hire Pune, Goa Sightseeing Bus Booking Pune, Goa Local Sightseeing Bus Pune, Goa Tour Bus for Sightseeing from Pune, Goa Tourist Bus from Pune, Goa Tourist Bus Rental from Pune, Goa Tourist Bus Hire from Pune, Goa Tourist Bus Booking from Pune, North Goa Tour Bus from Pune, South Goa Tour Bus from Pune, North Goa Sightseeing Bus Pune, South Goa Sightseeing Bus Pune, Goa Beach Tour Bus from Pune, Goa Beach Sightseeing Bus Pune, Goa Resort Transfer Bus Pune to Goa, Goa Hotel Transfer Bus Pune, Goa Airport Transfer Bus Pune, Goa Group Transportation from Pune, Goa Family Transportation from Pune, Goa Tourist Transportation from Pune, Goa Holiday Transportation from Pune, Goa One Way Bus from Pune, Goa One Way Bus Rental Pune, Goa Round Trip Bus Pune to Goa, Goa Round Trip Bus Rental Pune, Goa Multi Day Bus Rental Pune to Goa, Goa Multi Day Bus Hire Pune, Goa Multi Day Bus Booking Pune, 20 Seater Bus Pune to Goa, 26 Seater Bus Pune to Goa, 32 Seater Bus Pune to Goa, 35 Seater Bus Pune to Goa, 45 Seater Bus Pune to Goa, 50 Seater Bus Pune to Goa, 20 Seater Bus Rental Pune to Goa, 26 Seater Bus Rental Pune to Goa, 32 Seater Bus Rental Pune to Goa, 35 Seater Bus Rental Pune to Goa, 45 Seater Bus Rental Pune to Goa, 50 Seater Bus Rental Pune to Goa, 20 Seater Goa Tour Bus Pune, 26 Seater Goa Tour Bus Pune, 32 Seater Goa Tour Bus Pune, 35 Seater Goa Tour Bus Pune, 45 Seater Goa Tour Bus Pune, 50 Seater Goa Tour Bus Pune, Pune to Goa Baga Beach Bus, Pune to Goa Calangute Beach Bus, Pune to Goa Anjuna Beach Bus, Pune to Goa Vagator Beach Bus, Pune to Goa Candolim Bus, Pune to Goa Fort Aguada Bus, Pune to Goa Panjim Bus, Pune to Goa Dona Paula Bus, Pune to Goa Miramar Beach Bus, Pune to Goa Old Goa Bus, Pune to Goa Basilica of Bom Jesus Bus, Pune to Goa Colva Beach Bus, Pune to Goa Benaulim Beach Bus, Pune to Goa Palolem Beach Bus, Pune Goa Bus Rental Kothrud, Pune Goa Bus Rental Baner, Pune Goa Bus Rental Aundh, Pune Goa Bus Rental Wakad, Pune Goa Bus Rental Hinjewadi, Pune Goa Bus Rental Viman Nagar, Pune Goa Bus Rental Kharadi, Pune Goa Bus Rental Hadapsar, Pune Goa Bus Rental Magarpatta, Pune Goa Bus Rental Kalyani Nagar, Pune Goa Bus Rental Shivajinagar, Pune Goa Bus Rental Swargate, Pune Goa Bus Rental Kondhwa, Pune Goa Bus Rental Katraj, Pune Goa Bus Rental Pimpri, Pune Goa Bus Rental Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goatourpackagefrom;